<template>
  <div class="v-register" style="overflow-y: hidden">
    <v-app>
      <v-main>
        <div v-if="state.loading" class="container text-center" style="margin-top: 50px">
          <pulse-loader></pulse-loader>
        </div>
        <div v-else>
          <Start v-if="state.appStage.currentProgress == 'start'" :form-total="formTotal"></Start>
          <MeetingProducts
              v-if="state.appStage.currentProgress == 'lookup' && state.member.meeting.registrationProducts.length > 1"></MeetingProducts>
          <Form v-if="state.appStage.currentProgress == 'form'" :form-total="formTotal"></Form>
          <Success v-if="state.appStage.currentProgress == 'success'" :form-total="formTotal"></Success>

        </div>
      </v-main>
    </v-app>
  </div>
</template>


<script>
import {mapGetters} from 'vuex'
import Start from "@/components/Start";
import MeetingProducts from './components/MeetingProducts';
import Form from './components/Form'
import Success from './components/Success'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  name: 'App',

  components: {
    MeetingProducts,
    Form,
    Success,
    PulseLoader,
    Start
  },

  data: () => ({
    //
  }),
  computed: {
    ...mapGetters({
      state: 'getState',
    }),
    formTotal: function () {
      let regPrice = 0

      if(this.state.member.meeting.registrationSelected){
        regPrice = this.state.member.meeting.registrationSelected.price;
      }

      let extraPrice = this.state.member.meeting.extraProductsSelected.reduce(function (prev, cur) {

        let prodTotal = 0;

        let q = 1;

        if (cur.quantity) {
          q = cur.quantity
        }


        if (q && cur.price > 0) {

          prodTotal = cur.price * q;
        }


        return prev + prodTotal;
      }, 0);

      let donationAmount = 0
      if (this.state.donation.amount > 0){
        donationAmount = this.state.donation.amount
      }

      let mulliganAmount = 0
      if (this.state.mulligan_pack.amount > 0 ){
        mulliganAmount = this.state.mulligan_pack.amount
      }

      let rawTotal = parseFloat(regPrice) + parseFloat(extraPrice) + parseFloat(donationAmount) + parseFloat(mulliganAmount)

      let ft = new Intl.NumberFormat('en-US', {
        style: 'currency', currency: 'USD'
      }).format(rawTotal);

      return {
        intVal: rawTotal,
        display: ft
      };

    }
  },
  mounted: function () {
    this.$store.dispatch('getRates');
  }
};
</script>

<style>

.v-register {
  font-family: Roboto, sans-serif !important;

}

.v-data-table__wrapper {
  /*overflow-x: hidden !important;*/
}

.slide-fade-enter-active {
  transition: all .3s ease;
}

.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter, .slide-fade-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */
{
  transform: translateX(10px);
  opacity: 0;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.v-icon {
  margin-right: 10px;
}

.v-register .v-data-table__wrapper {
  overflow-x: hidden !important;
}
</style>
